import React, { useState, useEffect } from "react";
import axios from 'axios';
import Loader from "../../../components/loader";
import './billingDiscrepancy.scss';
import { Tooltip } from 'react-tooltip';
import { connect } from "react-redux";
import { utils, writeFile } from 'xlsx';
import { clone, sortBy, isPlainObject, isObject } from "lodash";

const BillingDiscrepancyReport = props => {
    const [loading, setLoading] = useState();
    const [report, reportState] = useState([]);
    const [filteredReport, setFilteredReport] = useState([]);
    const [reviewedReport, setReviewed] = useState([]);

    async function getReport() {
        setLoading(true);
        let reportData = await axios.get('/api/billing-services/discrepancy-report', {
            headers: {
                authentication: props.UserReducer.token
            }
        }).catch(e => e);
        let report = reportData?.data || {};
        reportState(report);
        setFilteredReport(report?.discrepancies || []);
        setReviewed(report?.reviewed || []);
        setLoading(false);
    };

    useEffect(() => {
        getReport();
    }, []);

    function searchAll(text) {
        let searchRgx = new RegExp((text || /.+/), 'i');
        let searched = report.discrepancies.filter(client => {
            return searchRgx.test(JSON.stringify(client))
        });
        let searchedR = report.reviewed.filter(client => {
            return searchRgx.test(JSON.stringify(client))
        });
        setFilteredReport(searched);
        setReviewed(searchedR);
    }

    function exportToExcel() {
        let transformedData = transformDataForExport(filteredReport);
        let ws = utils.json_to_sheet(transformedData);
        let wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Discrepancy Report");
        writeFile(wb, "Billing_Discrepancy.xlsx");
    }

    async function markAsReviewed(company, key, index) {
        let query = { billingCategory: key, companyId: company.companyId };
        await axios.post('/api/billing-services/mark-as-reviewed', query);
        return handleReviewMark(company, index, key, true);
    };

    async function removeReviewMark(company, key, index) {
        await axios.delete(`/api/billing-services/remove-review/${company.companyId}/${key}`);
        return handleReviewMark(company, index, key);
    };

    function handleReviewMark(company, index, key, mark) {
        let { companyId, companyName, shortName } = company;
        let item = clone(company[key]);
        delete company[key];
        item.reviewed = !item?.reviewed;
        let otherKeys = Object.values(company).filter(v => isPlainObject(v)).length;
        if (mark) {
            if (!otherKeys) {
                filteredReport.splice(index, 1);
            };
            setFilteredReport([...filteredReport]);
            let found = reviewedReport.find(co => co.companyId === companyId);
            if (found) {
                found[key] = item;
            } else {
                reviewedReport.push({ [key]: item, companyId, companyName, shortName });
            };
            setReviewed(sortBy(reviewedReport, "shortName"));
        } else {
            if (!otherKeys) {
                reviewedReport.splice(index, 1);
            }
            setReviewed([...reviewedReport]);
            let found = filteredReport.find(co => co.companyId === companyId);
            if (found) {
                found[key] = item;
            } else {
                filteredReport.push({ [key]: item, companyId, shortName, companyName });
            };
            setFilteredReport(sortBy(filteredReport, "shortName"));
        };
    };

    function transformDataForExport(data) {
        return data.reduce((list, company) => {
            let { companyName, shortName } = company;
            for (let serviceName in company) {
                if (isObject(company[serviceName]) && !Array.isArray(company[serviceName])) {
                    list.push({
                        shortName,
                        companyName,
                        serviceName,
                        enabled: company[serviceName].enabled,
                        billed: company[serviceName].billed
                    });
                };
            };
            return list;
        }, []);
    };

    return (<div className="df ffc wp_report_page">
        <div className="df download_actns">
            <div className="mla">
                <button onClick={exportToExcel} disabled={loading} className="export_btn" title="export to excel"></button>
            </div>
        </div>

        <div className="df filters_wrpr billing">
            <input
                type="text"
                disabled={loading}
                onChange={(e) => searchAll(e.target.value)}
                placeholder="Search..."
            ></input>
        </div>
        {loading ? (
            <div className="table_wrpr w75">
                <div className='loading-data d-flex align-items-center justify-content-center'>
                    <Loader></Loader>
                </div>
            </div>
        ) : (
            <div
                className="table_wrpr w75"
            >
                <div className="client_header align-items-center df justify-content-between" >
                    <div className="header"></div>
                    <div className="client_block_outer">
                        <div className="df fww acse client_block justify-content-between">
                            <h5 className="lw_clc_25 fwm">Service</h5>
                            <h5 className="lw_clc_25 fwm">Enabled</h5>
                            <h5 className="lw_clc_25 fwm">Billed</h5>
                            <h5 className="lw_clc_25 fwm">Review</h5>
                        </div>
                    </div>
                </div>

                <div className="client_block_scroll">
                    {filteredReport?.map((client, index) => {
                        return (<div className="client_wrpr align-items-center df justify-content-between" key={client.shortName}>
                            <div className="header">
                                <h4 className="client_hdr">{client.shortName}</h4>
                                <h4 className="client_hdr">{client.companyName}</h4>
                            </div>
                            <div className="client_block_outer">


                                <div className="client_block">

                                    {Object.keys(client).sort().map(key => {
                                        return (
                                            isObject(client[key]) && (client[key].enabled != client[key].billed) && <div
                                                key={`${client.companyId}-${key}`}
                                                className={`df fww acse w100 line_padding justify-content-between `}>
                                                <p className="lw_clc_25">{key}</p>
                                                <p className={`lw_clc_25 ${client[key].enabled ? "green" : "red"}-dot`}></p>
                                                <p className={`lw_clc_25 ${client[key].billed ? "green" : "red"}-dot`}
                                                    data-tip={client[key].billed ? `Billed Services: <br/>${client[key].billedServices.join("<br/>")}` : ""}
                                                    data-for={`${client.companyId}-${key}-tt`}
                                                    data-multiline="true"
                                                ></p>
                                                <Tooltip id={`${client.companyId}-${key}-tt`} />
                                                <a role="button" className="lw_clc_25" onClick={() => markAsReviewed(client, key, index)}>Mark As Reviewed</a>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>)
                    })}
                    {reviewedReport?.map((client, index) => {
                        return (<div className="client_wrpr align-items-center df justify-content-between reviewed" key={client.shortName}>
                            <div className="header">
                                <h4 className="client_hdr">{client.shortName}</h4>
                                <h4 className="client_hdr">{client.companyName}</h4>
                            </div>
                            <div className="client_block_outer">
                                <div className="client_block">
                                    {Object.keys(client).sort().map(key => {
                                        return (
                                            isObject(client[key]) && (client[key].enabled != client[key].billed) && <div
                                                key={`${client.companyId}-${key}`}
                                                className={`df fww acse w100 line_padding justify-content-between `}>
                                                <p className="lw_clc_25">{key}</p>
                                                <p className={`lw_clc_25 ${client[key].enabled ? "green" : "red"}`}></p>
                                                <p className={`lw_clc_25 ${client[key].billed ? "green" : "red"}`}
                                                    data-tip={client[key].billed ? `Billed Services: <br/>${client[key].billedServices.join("<br/>")}` : ""}
                                                    data-for={`${client.companyId}-${key}-tt`}
                                                    data-multiline="true"
                                                ></p>
                                                <Tooltip id={`${client.companyId}-${key}-tt`} />
                                                <a role="button" className="lw_clc_25" onClick={() => removeReviewMark(client, key, index)}>Remove Reviewed Mark</a>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>)
                    })}
                </div>
            </div>
        )}
    </div>)

}


const mapStateToProps = ({ UserReducer }) => ({ UserReducer });
export default connect(mapStateToProps, {})(BillingDiscrepancyReport);
